import { authAPIUrl } from "@/environment";

import { createOldApiClient, createRawApiClient, refreshAuthToken } from "./apiClient";

const apiClient = createOldApiClient(authAPIUrl);
const rawApiClient = createRawApiClient(authAPIUrl);

export function loginLookup(email) {
  return rawApiClient.get("/auth/login", { params: { email, type: "", path: "" } });
}

export function register(payload) {
  return apiClient.post("/auth/register", payload, { timeout: 90000 });
}

export default {
  canSetup() {
    // The endpoint returns {success: <is_setup_done>}; the setup page should
    // be reachable only when setup is NOT done yet. Fall back to allowing
    // access if the call fails so installers can still recover.
    return apiClient
      .get("/onprem/setup")
      .then((res) => !res.data || !res.data.success)
      .catch(() => true);
  },
  setup(params) {
    return apiClient.post("/onprem/setup", params, { timeout: 20000 });
  },
  isAuthenticated() {
    return apiClient.get("/auth/user?type=admin");
  },
  isAuthenticatedSilent() {
    return rawApiClient.get("/auth/user?type=admin");
  },
  logout() {
    return apiClient.get("/auth/logout?type=admin");
  },
  refreshToken() {
    return refreshAuthToken();
  },
  getServerInfo() {
    return apiClient.get("v1/server-info");
  },
};
